import { render, staticRenderFns } from "./menuGroups.vue?vue&type=template&id=4d42d10c&scoped=true"
import script from "./menuGroups.vue?vue&type=script&lang=js"
export * from "./menuGroups.vue?vue&type=script&lang=js"
import style0 from "./menuGroups.vue?vue&type=style&index=0&id=4d42d10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d42d10c",
  null
  
)

export default component.exports